import { Modal, View } from '@mirai/ui';
import PropTypes from 'prop-types';
import React from 'react';

import * as style from './ModalUrl.module.css';

const ModalUrl = ({ title, url, visible, onClose = () => {}, ...others }) => {
  const handleClose = () => {
    onClose();
  };

  return (
    <Modal
      {...others}
      fit
      title={title}
      visible={visible}
      onClose={handleClose}
      onOverflow={handleClose}
      className={style.modal}
    >
      <View
        tag="iframe"
        referrerpolicy="strict-origin-when-cross-origin"
        src={url}
        title="modal"
        className={style.content}
      />
    </Modal>
  );
};

ModalUrl.propTypes = {
  url: PropTypes.string,
  title: PropTypes.string,
  visible: PropTypes.bool,
  onClose: PropTypes.func,
};

ModalUrl.displayName = 'Mirai:Core:Rates:Item:ModalUrl';

export { ModalUrl };
